import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

/**
 * PrintService — Angular 18.
 *
 * Bridges a print request from the migrated print header (`app-header-print`)
 * to the AngularJS `AppController`, which rebroadcasts `AppController::print`
 * to the active print controller.
 *
 * This replaces the old `Header::print` `$scope.$emit` → `AppController` event
 * hop. A direct output binding from `<ng-header-print>` to `AppController` is
 * not viable: the print header lives in the print controller's scope (via the
 * shared `layouts/print.tpl.html`), several layers below `AppController`. A
 * root-provided RxJS service is the decoupled bridge across that gap.
 *
 * Registered into AngularJS under 'PrintService' via downgradeInjectable in
 * app/upgrade/ng-downgraded-components.ts.
 */
@Injectable({ providedIn: 'root' })
export class PrintService {
  private readonly printSubject = new Subject<void>();

  /** Emits each time a print is requested from the print header. */
  readonly print$ = this.printSubject.asObservable();

  /** Request a print (called by the print header's Print link). */
  requestPrint(): void {
    this.printSubject.next();
  }
}
